import { Offset } from "@/models/pdfModels";
import { jsPDF, TextOptionsLight } from "jspdf";
import { Challenge, TeamReference } from "@/models/pdfData";

export const offset: (xInput: number, yInput: number) => Offset = (
  xInput,
  yInput,
) => {
  const xOffset: Offset["x"] = (x) => x + xInput;
  const yOffset: Offset["y"] = (y) => y + yInput;
  return { x: xOffset, y: yOffset };
};

export const trim = (input: string, maxLength: number): string => {
  if (input.length <= maxLength) {
    return input;
  } else {
    return `${input.substring(0, maxLength - 3).trimEnd()}...`;
  }
};

export const centeredText: (
  doc: jsPDF,
  text: string,
  xCoordinate: number,
  yCoordinate: number,
  maxWidth: number,
  additionalOptions?: TextOptionsLight,
) => jsPDF = (
  doc,
  text,
  xCoordinate,
  yCoordinate,
  maxWidth,
  additionalOptions,
) => {
  return doc.text(text, xCoordinate, yCoordinate, {
    align: "center",
    maxWidth,
    ...additionalOptions,
  });
};

export const getTableColumFunctions: () => {
  columnEnd: (index: number) => number;
  columnWidth: number[];
  columnStart: (index: number) => number;
  columnCenter: (index: number) => number;
} = () => {
  const columnWidth = [8, 14, 14, 10, 20, 20, 35, 11, 11, 11, 20];
  const columnStart = (index: number) =>
    columnWidth.reduce(
      (sum, width, i) => (i < index - 1 ? sum + width : sum),
      0,
    );
  const columnCenter = (index: number) =>
    columnWidth.reduce(
      (sum, width, i) =>
        i < index ? sum + width : i === index ? sum + width / 2 : sum,
      0,
    );
  const columnEnd = (index: number) =>
    columnWidth.reduce((sum, width, i) => (i < index ? sum + width : sum), 0);

  return { columnWidth, columnStart, columnCenter, columnEnd };
};

export const otherTeam = <T extends TeamReference | Challenge["team"]>(
  team: T,
): T => {
  if (team === "ref") {
    return "ref" as T;
  } else if (team === "team1") {
    return "team2" as T;
  } else {
    return "team1" as T;
  }
};
